import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '@/services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
  bearer: string;
};

type HookTuple = [
  response: vp.FedwireTransactionResponse | undefined,
  fetchData: (params: vp.TransactionRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchFedwireWithdrawTransaction: ApiHook = ({ api, bearer }: HookProps) => {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.TransactionRequest>({
    TransactionID: '',
    Timezone: 'UTC',
  });
  const [response, setResponse] = useState<vp.FedwireTransactionResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async () => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen', true);

      const res = await api.fetchFedwireWithdrawTransaction(params, bearer, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false, 'loading some data', 'fullScreen', false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest();

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (params: vp.TransactionRequest) => {
      setParams(params);
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchFedwireWithdrawTransaction);
